<template>
  <div class="user_navi">
    <div :class="`user_navi_one ` + ($route.meta.title==='我的信息' ? 'user_navi_selected' : '')" @click="toUserDetail">
      我的信息
    </div>
    <div :class="`user_navi_one ` + ($route.meta.title==='已购项目' ? 'user_navi_selected' : '')" @click="toCoupons">
      已购项目
    </div>
    <div :class="`user_navi_one ` + ($route.meta.title==='服务记录' ? 'user_navi_selected' : '')" @click="toUsed">
      服务记录
    </div>
    <div :class="`user_navi_one ` + ($route.meta.title==='修改密码' ? 'user_navi_selected' : '')" @click="toPassword">
      修改密码
    </div>
  </div>
</template>

<script>
  import { getJsonStorage } from "../../util/storage";

  export default {
    name: "UserNavi",
    data() {
      return {

      }
    },
    mounted(){

    },
    methods: {
      toPassword(){
        if(this.$route.meta.title!=='修改密码'){
          this.$router.push('/user/password');
        }
      },
      toUserDetail(){
        this.$router.push('/user/detail');
      },
      toCoupons(){
        if(this.$route.meta.title!=='已购项目'){
          this.$router.push('/user/coupons');
        }
      },
      toUsed(){
        if(this.$route.meta.title!=='服务记录'){
          this.$router.push('/user/used');
        }
      }
    }
  }
</script>

<style scoped>
  .user_navi {
    width: 100%;
    height:5vh;
    line-height:5vh;
    top:6vh;
    font-size:.8rem;
    color:#666;
  }
  .user_navi_one {
    width:21%;
    margin:0 2%;
    float:left;
    height:5vh;
    line-height:5vh;
    text-align:center;
  }
  .user_navi_selected {
    line-height:4vh;
    font-weight:bold;
    font-size:1rem;
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/navi.vue